import { createSelector } from "reselect";

const cpRegistriesPreviewSelector = state => state.cp.registriesPreview;

export const isLoadingSelector = createSelector(
	cpRegistriesPreviewSelector,
	state => state.isLoading
);
export const isNoItemsSelector = createSelector(
	cpRegistriesPreviewSelector,
	state => state.isNoItems
);
export const scrollSelector = createSelector(
	cpRegistriesPreviewSelector,
	state => state.scroll
);
export const searchSelector = createSelector(
	cpRegistriesPreviewSelector,
	state => state.search
);
export const filterSelector = createSelector(
	cpRegistriesPreviewSelector,
	state => state.filter
);
export const registriesSelector = createSelector(
	cpRegistriesPreviewSelector,
	state => state.registries
);
export const itemsSelector = createSelector(
	cpRegistriesPreviewSelector,
	state => state.items
);
export const actionSelector = createSelector(
	cpRegistriesPreviewSelector,
	state => state.action
);
